import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

@Pipe({
  name: 'markdown',
  standalone: true,
})
export class MarkdownPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  public transform(value?: string | null): SafeHtml {
    if (!value) return '';

    const html = marked.parse(value, { async: false, breaks: true });
    const safeHtml = DOMPurify.sanitize(html);

    return this.sanitizer.bypassSecurityTrustHtml(safeHtml);
  }
}
